module.exports = __webpack_public_path__ + "static/media/homeBannerCN.c3c9b76c.png";